function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { getGlobalScope, addBreadcrumb, getCurrentScope, getClient } from '@sentry/core';
import { addNonEnumerableProperty } from '@sentry/utils'; // Inline PiniaPlugin type

var createSentryPiniaPlugin = function createSentryPiniaPlugin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    attachPiniaState: true,
    addBreadcrumbs: true,
    actionTransformer: function actionTransformer(action) {
      return action;
    },
    stateTransformer: function stateTransformer(state) {
      return state;
    }
  };

  var plugin = function plugin(_ref) {
    var store = _ref.store;
    options.attachPiniaState !== false && getGlobalScope().addEventProcessor(function (event, hint) {
      try {
        // Get current timestamp in hh:mm:ss
        var timestamp = new Date().toTimeString().split(' ')[0];
        var filename = "pinia_state_".concat(store.$id, "_").concat(timestamp, ".json");
        hint.attachments = [].concat(_toConsumableArray(hint.attachments || []), [{
          filename: filename,
          data: JSON.stringify(store.$state)
        }]);
      } catch (_) {// empty
      }

      return event;
    });
    store.$onAction(function (context) {
      context.after(function () {
        var transformedActionName = options.actionTransformer ? options.actionTransformer(context.name) : context.name;

        if (typeof transformedActionName !== 'undefined' && transformedActionName !== null && options.addBreadcrumbs !== false) {
          addBreadcrumb({
            category: 'action',
            message: transformedActionName,
            level: 'info'
          });
        }
        /* Set latest state to scope */


        var transformedState = options.stateTransformer ? options.stateTransformer(store.$state) : store.$state;
        var scope = getCurrentScope();
        var currentState = scope.getScopeData().contexts.state;

        if (typeof transformedState !== 'undefined' && transformedState !== null) {
          var client = getClient();

          var _options = client && client.getOptions();

          var normalizationDepth = _options && _options.normalizeDepth || 3; // default state normalization depth to 3

          var piniaStateContext = {
            type: 'pinia',
            value: transformedState
          };

          var newState = _objectSpread(_objectSpread({}, currentState || {}), {}, {
            state: piniaStateContext
          });

          addNonEnumerableProperty(newState, '__sentry_override_normalization_depth__', 3 + // 3 layers for `state.value.transformedState
          normalizationDepth // rest for the actual state
          );
          scope.setContext('state', newState);
        } else {
          scope.setContext('state', _objectSpread(_objectSpread({}, currentState || {}), {}, {
            state: {
              type: 'pinia',
              value: 'undefined'
            }
          }));
        }
      });
    });
  };

  return plugin;
};

export { createSentryPiniaPlugin };